import { React, useEffect, useState, useContext, useRef } from 'react';
import { AuthContext } from '../../../../contexts/authContext/index';
import { useNavigate, useLocation } from 'react-router-dom';

import { TextInput, Textarea, Autocomplete, Select, Modal, Button, FileButton, Checkbox } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useForm } from '@mantine/form';
import { DatePickerInput } from '@mantine/dates';
import { addYears, addDays } from 'date-fns';
import { IconX, IconPlus, IconTrash } from '@tabler/icons-react';
import 'dayjs/locale/fr';

import AddOfferHd from '../../../../composents/Headers/Customized/AddOfferHd/AddOfferHd';
import AppDesktopLogo from '../../../../composents/Logo/AppDesktopLogo/AppDesktopLogo';
import SyndicRectangleButton from '../../../../composents/Buttons/Syndic/RectangleButton/RectangleButtonMain';
import ResourceCategorySelect from '../../../Constants/ResourceCategorySelect'
import RessourcesRequiringWeight from '../../../Constants/RessourcesRequiringWeight'

function AddNewOffer() {
    const { getToken } = useContext(AuthContext);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [previewPictures, setPreviewPictures] = useState(() => {
        try { return JSON.parse(sessionStorage.getItem("addOfferDraftPictures")) || []; } catch { return []; }
    });

    const [ openedImgLimit, { open : openModalImgLimit, close : closeModalImgLimit }] = useDisclosure(false);
    const [ openedExistingImg, { open: openModalExistingImg, close: closeModalExistingImg}] = useDisclosure(false)
    const [ openedTooBigImg, { open: openModalTooBigImg, close: closeModalTooBigImg}] = useDisclosure(false)
    const [ openedModalWrongType, { open: openModalWrongType, close: closeModalWrongType}] = useDisclosure(false);
    const [ openedModalDraftPicturesLost, { open: openModalDraftPicturesLost, close: closeModalDraftPicturesLost}] = useDisclosure(false);
    const [tempRange, setTempRange] = useState([]);
    const [query, setQuery] = useState(() => {
        try { return JSON.parse(sessionStorage.getItem("addOfferDraft"))?.cityOfIntervention || ''; } catch { return ''; }
    });
    const [options, setOptions] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitError, setSubmitError] = useState(null);
    const [cautionModalOpened, setCautionModalOpened] = useState(false);
    const [pendingSubmit, setPendingSubmit] = useState(null);
    const cautionInputRef = useRef(null);
    // const [cityOfIntervention, setCityOfIntervention] = useState('');
    const navigate = useNavigate();

    const location = useLocation();

    useEffect(() => {
        const token = getToken();
        if (!token) {
            navigate("/app/login");
            return;
        };

        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
          };
          window.addEventListener('resize', handleResize);
          return () => {
            window.removeEventListener('resize', handleResize);
          };
          // eslint-disable-next-line react-hooks/exhaustive-deps
    },[location.state]);

    const savedFormValues = (() => {
        try { return JSON.parse(sessionStorage.getItem("addOfferDraft")); } catch { return null; }
    })();

    const defaultFormValues = {
        title: '',
        contrat: '',
        cityOfIntervention: '',
        availabilityDates: [],
        ressource: '',
        description: '',
        rules: '',
        price: 0,
        caution: '',
        allowWeekends: true,
        allowHolidays: true,
        rentUnit: 'jour',
        pictures:[],
        handDelivery: true,
        shipping: false,
        weightKg: ''
    };

    const form = useForm({
      initialValues: savedFormValues ? { ...defaultFormValues, ...savedFormValues } : defaultFormValues,

      validate: {
        title : (value) => (
            value.length < 1
            ? 'Renseignez le titre de votre offre'
            : value.length > 100
            ? '100 caractères maximum'
            : null
        ),
        availabilityDates: (value, values) => {
            if (values.contrat === "Location") {
                if (!value || value.length === 0) {
                return "Sélectionnez les dates de disponibilités de votre location";
                }
            }
            return null;
        },
        weightKg: (value, values) => {
            // Le poids ne sert qu'au calcul CO2, jamais fait pour une Location (cf. backend
            // calculateAvoidedCO2 qui retourne null immédiatement pour une Location) — donc
            // pas la peine de le demander dans ce cas.
            if (values.contrat !== "Location" && RessourcesRequiringWeight.includes(values.ressource)) {
                const parsed = parseFloat(String(value).replace(',', '.'));
                if (!value || isNaN(parsed) || parsed <= 0) {
                    return "Indiquez le poids (en kg) de cette ressource";
                }
            }
            return null;
        },
        price: (value, values) => {
            const priceValue = parseFloat(String(value).replace(',', '.'));
            if (values.contrat !== "Don" && priceValue < 1) {
                return "Le prix minimum est de 1 €";
            }
            return null;
        },
        description : (value) => (value.length > 1000 ? '1000 caractères maximum' : null),
        rules : (value) => (value.length > 1000 ? '1000 caractères maximum' : null),
        cityOfIntervention: (value) => (
            /^\d{5}\s.+/.test(String(value || '').trim())
                ? null
                : 'Sélectionnez une ville dans la liste proposée (code postal et commune)'
        )
       },
    });

    // Changer de type de contrat invalide les plages de disponibilités déjà
    // saisies : elles n'ont de sens que pour une Location, pas pour quitter
    // ce type vers Vente/Don.
    const handleContratChange = (newContrat) => {
        if (form.values.contrat === "Location" && newContrat !== "Location") {
            form.setFieldValue("availabilityDates", []);
            setTempRange([]);
        }
        form.setFieldValue("contrat", newContrat);
    };

    // const handleQueryChange = async (value) => {
    //     setQuery(value);

    //     if (value) {
    //         try {
    //             const token = localStorage.getItem('token');
    //             const response = await fetch('https://boldee-97d8d36af3bd.herokuapp.com/app/offers/search-cityOfIntervention', {
    //                 method: 'POST',
    //                 body: JSON.stringify({ query: value }),
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     Authorization: `Bearer ${token}`
    //                 }          
    //             })

    //             if (!response.ok) {
    //                 throw new Error('Network response was not ok');
    //               }
    //             const data = await response.json();
    //             const suggestionsMap = new Map();

    //             data.features.forEach((feature) => {
    //             const city = feature.properties.city || '';
    //             const postcode = feature.properties.postcode || '';
    //             const suggestionKey = `${city}-${postcode}`;

    //             suggestionsMap.set(suggestionKey, {
    //                 value: `${postcode} ${city}`,
    //                 label: `${postcode} ${city}`,
    //                 postcode: postcode,
    //                 city: city
    //             });
    //             });

    //             const uniqueSuggestions = Array.from(suggestionsMap.values());

    //             setOptions(uniqueSuggestions);
    //         } catch (error) {
    //         }
    //     }
    
    // };
    const handleQueryChange = async (value) => {
        setQuery(value);

        if (value.length < 2) {
            setOptions([]);
            return;
        }

        try {
            const response = await fetch(
            `https://api-adresse.data.gouv.fr/search/?q=${value}&type=municipality&limit=5`
            );

            const data = await response.json();

            const suggestions = data.features.map((feature) => {
            const city = feature.properties.city;
            const postcode = feature.properties.postcode;

            return {
                value: `${postcode} ${city}`,
                label: `${postcode} ${city}`
            };
            });

            setOptions(suggestions);
        } catch (error) {
            console.error(error);
        }
        };

    // const handleQuerySubmit = (citySelected) => {
    //     setCityOfIntervention(citySelected.target.value) 
    // };   
    
    // Redimensionne/recompresse une image data URL pour qu'elle tienne dans sessionStorage
    // (limite ~5-10 Mo/origine : 3 photos proches des 10 Mo max acceptés à l'upload peuvent
    // peser jusqu'à 40 Mo une fois encodées en base64, ce qui fait échouer silencieusement la
    // sauvegarde du brouillon avant la redirection vers l'enregistrement de carte bancaire,
    // et les photos disparaissent au retour sur le formulaire).
    const compressImageForDraft = (dataUrl, maxDimension = 1280, quality = 0.7) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
                let { width, height } = img;
                if (width > maxDimension || height > maxDimension) {
                    const scale = maxDimension / Math.max(width, height);
                    width = Math.round(width * scale);
                    height = Math.round(height * scale);
                }
                const canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);
                resolve(canvas.toDataURL('image/jpeg', quality));
            };
            img.onerror = () => resolve(dataUrl);
            img.src = dataUrl;
        });
    };

    const saveOfferDraft = async () => {
        try {
            sessionStorage.setItem("addOfferDraft", JSON.stringify({ ...form.values, cityOfIntervention: query }));
            const compressedPictures = await Promise.all(previewPictures.map(pic => compressImageForDraft(pic)));
            sessionStorage.setItem("addOfferDraftPictures", JSON.stringify(compressedPictures));
            return true;
        } catch (storageError) {
            console.error("Impossible de sauvegarder le brouillon de l'offre :", storageError);
            sessionStorage.removeItem("addOfferDraftPictures");
            return false;
        }
    };

    const doSubmitOffer = async (values, _event) => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        const priceNumber = parseFloat(String(form.values.price).replace(',', '.'));

        const formattedDates = values.availabilityDates.map((range) => ({
            startDate: range.startDate,
            endDate: range.endDate
        }));

        try {
            const token = localStorage.getItem('token');

            // Vérifier si carte enregistrée. En cas d'échec réseau/serveur transitoire, on ne
            // doit pas traiter ça comme "pas de carte" (ce qui redemanderait inutilement une
            // carte déjà enregistrée) : on bloque la publication avec un message explicite
            // plutôt que de rediriger à tort vers l'enregistrement de carte.
            let cardData;
            try {
                const cardRes = await fetch(
                    "https://boldee-97d8d36af3bd.herokuapp.com/app/payment/setup-intent/status",
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                if (!cardRes.ok) throw new Error("setup-intent/status a échoué");
                cardData = await cardRes.json();
            } catch (cardCheckError) {
                console.error("Impossible de vérifier la carte enregistrée :", cardCheckError);
                setIsSubmitting(false);
                setSubmitError("Impossible de vérifier votre moyen de paiement pour le moment. Veuillez réessayer dans quelques instants.");
                return;
            }
            if (!cardData.hasCard) {
                const draftSaved = await saveOfferDraft();
                if (!draftSaved && previewPictures.length > 0) {
                    setIsSubmitting(false);
                    openModalDraftPicturesLost();
                    return;
                }
                navigate("/app/payment/setup-card?redirect=/app/offers/add");
                return;
            }
            const cautionNumber = values.contrat === "Location" && values.caution !== ''
                ? parseFloat(String(values.caution).replace(',', '.'))
                : undefined;

            const response = await fetch("https://boldee-97d8d36af3bd.herokuapp.com/app/offers/add", {
                method: "POST",
                body: JSON.stringify({
                    title: values.title,
                    contrat: values.contrat,
                    cityOfIntervention: values.cityOfIntervention,
                    availabilityDates: formattedDates,
                    ressource: values.ressource,
                    description: values.description,
                    rules: values.rules,
                    price: priceNumber,
                    caution: cautionNumber,
                    allowWeekends: values.allowWeekends,
                    allowHolidays: values.allowHolidays,
                    pictures: previewPictures,
                    handDelivery: values.handDelivery,
                    shipping: values.shipping,
                    weightKg: values.contrat !== "Location" && RessourcesRequiringWeight.includes(values.ressource) && values.weightKg !== ''
                        ? parseFloat(String(values.weightKg).replace(',', '.'))
                        : undefined,

                }),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            });
            const newOffer = await response.json();

            if (!response.ok) {
                const message = Array.isArray(newOffer?.message) ? newOffer.message.join(' ') : (newOffer?.message || "Une erreur est survenue, veuillez réessayer.");
                setSubmitError(message);
                return;
            }
            setSubmitError(null);
            sessionStorage.removeItem("addOfferDraft");
            sessionStorage.removeItem("addOfferDraftPictures");
            sessionStorage.setItem("offer", JSON.stringify(newOffer));
            navigate(`/app/offers/add-preview/${newOffer._id}`)
        } catch (error) {
            setSubmitError("Une erreur est survenue, veuillez réessayer.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleFormSubmit = (values, _event) => {
        _event.preventDefault();
        const cautionEmpty = values.contrat === "Location" &&
            (values.caution === '' || parseFloat(String(values.caution).replace(',', '.')) === 0);
        if (cautionEmpty) {
            setPendingSubmit({ values, event: _event });
            setCautionModalOpened(true);
            return;
        }
        doSubmitOffer(values, _event);
    };

    const fileBrowseHandler = (event) => {
        let readers = [];
        const limitImages = 3
        const maxSizeInBytes = 10*1024*1024
        for(let i = 0;i < event.length;i++){
           
            if(event[i].size > maxSizeInBytes) {
                openModalTooBigImg()
            } else if(event[i].type !== 'image/png' && event[i].type !== 'image/jpeg' && event[i].type !== 'image/jpg'){
                openModalWrongType()
            } else if (event[i].size <= maxSizeInBytes) {
            let reader = new FileReader();
            reader.readAsDataURL(event[i])
            reader.onload = () => {
                if(!previewPictures.concat([...readers]).includes(reader.result)) {
                    readers.push(reader.result);
                    if(previewPictures.concat([...readers]).length <= limitImages ) {
                        setPreviewPictures(previewPictures.concat([...readers]))
                    }   else if (previewPictures.concat([...readers]).length > limitImages){
                        setPreviewPictures(previewPictures.concat([...readers]).slice(0,3))
                        openModalImgLimit()
                    }
                } else if (previewPictures.concat([...readers]).includes(reader.result)) {
                    openModalExistingImg()
                }
            };
           
              
            reader.onerror = function (error) {
            }
        }
        }      
    };

    const deleteImg = (event) => {
        const pictureToDelete = previewPictures.filter(picture => picture !== event.currentTarget.value);
        setPreviewPictures(pictureToDelete);
    };

    const isFrenchHoliday = (date) => {
        const y = date.getFullYear(), m = date.getMonth() + 1, d = date.getDate();
        // Calcul Pâques (algorithme de Butcher)
        const a = y % 19, b = Math.floor(y / 100), c = y % 100;
        const dd = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
        const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - dd - g + 15) % 30;
        const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
        const mm = Math.floor((a + 11 * h + 22 * l) / 451);
        const easterMonth = Math.floor((h + l - 7 * mm + 114) / 31);
        const easterDay = ((h + l - 7 * mm + 114) % 31) + 1;
        const easter = new Date(y, easterMonth - 1, easterDay);
        const lundi = new Date(easter); lundi.setDate(easter.getDate() + 1);
        const ascension = new Date(easter); ascension.setDate(easter.getDate() + 39);
        const pentecote = new Date(easter); pentecote.setDate(easter.getDate() + 50);
        const fixed = [[1,1],[5,1],[5,8],[7,14],[8,15],[11,1],[11,11],[12,25]];
        const isFixed = fixed.some(([fm, fd]) => m === fm && d === fd);
        const isMoving = [lundi, ascension, pentecote].some(fv =>
            fv.getFullYear() === y && fv.getMonth() + 1 === m && fv.getDate() === d
        );
        return isFixed || isMoving;
    };

    return(
        <>
            <Modal
                opened={cautionModalOpened}
                onClose={() => setCautionModalOpened(false)}
                title="Vous n'avez pas défini de caution"
                centered
                withCloseButton={false}
            >
                <p className="noMrgT">La caution vous protège en cas de dommage ou de non-restitution du bien. Sans caution, vous n'avez aucune garantie en cas de souci.</p>
                <div className="mrgB10"></div>
                <Button
                    fullWidth
                    color="dark"
                    onClick={() => {
                        setCautionModalOpened(false);
                        setTimeout(() => cautionInputRef.current?.focus(), 100);
                    }}
                >
                    Ajouter une caution
                </Button>
                <div className="mrgB10"></div>
                <Button
                    fullWidth
                    variant="outline"
                    color="gray"
                    onClick={() => {
                        setCautionModalOpened(false);
                        if (pendingSubmit) {
                            doSubmitOffer(pendingSubmit.values, pendingSubmit.event);
                            setPendingSubmit(null);
                        }
                    }}
                >
                    Continuer sans caution
                </Button>
            </Modal>
            {isMobile ? (
                <>
                    <AddOfferHd>Publier une nouvelle offre</AddOfferHd>
                    <form onSubmit={form.onSubmit(handleFormSubmit)}>
                        <div className="width90pCenter">
                            <div className='horizontal jCenter'>
                                {previewPictures.length > 0 
                                    ?   <div className='horizontal jCenter mrgB5'>
                                            {previewPictures.map( (picture, index) => (
                                                <div key = {picture} style = {{marginRight : '5px'}} className='vertical imgRelative'>
                                                    <img className='img78x78T' src={picture} alt='photo_chantier'/>
                                                    <button value={picture} onClick={deleteImg} className='btnReset imgDeleteImgBtnAbsolute mrgR5 mrgT5 bold bLiteTransparent'><IconX width={13} height={13}/></button>
                                                </div>
                                            ))}
                                        </div>
                                    :   ""
                                }

                                <FileButton
                                    className='img78x78T' 
                                    multiple
                                    onChange={fileBrowseHandler}
                                    accept="image/png,image/jpeg,image/jpg">
                                    {(props) => <Button variant="default" {...props}>
                                        <div className='vertical iCenter'>
                                            <IconPlus width={20}/> 
                                            <p className='noMrgTB txt11'>Ajouter photo (3 max)</p>
                                        </div> 
                                    </Button>}
                                </FileButton>

                                {openModalImgLimit  
                                    ?   <Modal 
                                            centered
                                            size="auto"
                                            opened={openedImgLimit}
                                            onClose={closeModalImgLimit}
                                            withCloseButton={false}>
                                            <p className=" txt15 txtCenter noMrgTB">
                                                Chargement de 3 photos maximum
                                            </p>
                                        </Modal> 
                                    :   ""
                                }

                                {openModalExistingImg  
                                    ?   <Modal 
                                            centered
                                            size="auto"
                                            opened={openedExistingImg}
                                            onClose={closeModalExistingImg}
                                            withCloseButton={false}>
                                            <p className=" txt15 txtCenter noMrgTB">
                                                Photo déjà téléchargée
                                            </p>
                                        </Modal> 
                                    :   ""
                                }
                                
                                {openModalTooBigImg  
                                    ?   <Modal 
                                            centered
                                            size="auto"
                                            opened={openedTooBigImg}
                                            onClose={closeModalTooBigImg}
                                            withCloseButton={false}>
                                            <p className="tCenter noMrgTB">
                                                10 Mo Maximum par photo
                                            </p>
                                        </Modal> 
                                    :   ""
                                }
                                {openModalWrongType
                                    ?   <Modal
                                            centered
                                            size="auto"
                                            opened={openedModalWrongType}
                                            onClose={closeModalWrongType}
                                            withCloseButton={false}>
                                            <p className="oMrgTB">
                                                Fichiers autorisés : .png, .jpeg, .jpg
                                            </p>
                                        </Modal>
                                    :   ""
                                }
                                {openedModalDraftPicturesLost
                                    ?   <Modal
                                            centered
                                            size="auto"
                                            opened={openedModalDraftPicturesLost}
                                            onClose={closeModalDraftPicturesLost}
                                            withCloseButton={false}>
                                            <p className="tCenter noMrgTB">
                                                Vos photos sont trop lourdes pour être conservées pendant l'enregistrement de votre carte. Réduisez leur nombre ou leur taille, puis réessayez.
                                            </p>
                                        </Modal>
                                    :   ""
                                }
                            </div>
                            <div className='mrgB10'></div>
                            <Select
                                variant="filled"
                                placeholder="Type de contrat"
                                data={[
                                    { value: 'Vente', label: 'Vente' },
                                    { value: 'Location', label: 'Location/Prestation' },
                                    { value: 'Don', label: 'Don' },
                                ]}
                                withAsterisk
                                {...form.getInputProps('contrat')}
                                onChange={handleContratChange}
                                 styles={{
                                    input: {
                                        color: 'black',
                                        fontWeight: 600,
                                    },
                                    placeholder: {
                                        fontWeight: 600,
                                    },
                                    groupLabel: {
                                        fontSize: '13px',
                                        fontWeight: 700,
                                        color: '#2e7d32',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        paddingTop: '8px',
                                    },
                                }}
                            />
                            <div className="mrgB10"></div>

                            {form.values.contrat === "Location" && (
                                <>    
                                <DatePickerInput
                                    type="range"
                                    allowSingleDateInRange
                                    value={tempRange}
                                    onChange={setTempRange}
                                    minDate={addDays(new Date(), 1)}
                                    maxDate={addYears(new Date(), 3)}
                                    placeholder="📅 Sélectionnez une plage"
                                    valueFormat="DD MMM YYYY"
                                    locale="fr"
                                    excludeDate={(date) => {
                                        const day = date.getDay();
                                        if (!form.values.allowWeekends && (day === 0 || day === 6)) return true;
                                        if (!form.values.allowHolidays && isFrenchHoliday(date)) return true;
                                        return form.values.availabilityDates?.some((range) => {
                                            if (!range?.startDate || !range?.endDate) return false;
                                            const current = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                                            const start = new Date(range.startDate.getFullYear(), range.startDate.getMonth(), range.startDate.getDate());
                                            const end = new Date(range.endDate.getFullYear(), range.endDate.getMonth(), range.endDate.getDate());
                                            return current >= start && current <= end;
                                        });
                                    }}
                                />

                                <div style={{ display: "flex", gap: 16, marginTop: 8 }}>
                                    <Checkbox
                                        label="Autoriser les week-ends"
                                        checked={form.values.allowWeekends}
                                        onChange={(e) => form.setFieldValue('allowWeekends', e.currentTarget.checked)}
                                    />
                                    <Checkbox
                                        label="Autoriser les jours fériés"
                                        checked={form.values.allowHolidays}
                                        onChange={(e) => form.setFieldValue('allowHolidays', e.currentTarget.checked)}
                                    />
                                </div>
                                <Button
                                    className='mrgT5'
                                    color="dark"
                                    onClick={() => {
                                        if (tempRange && tempRange[0] && tempRange[1] && new Date(tempRange[0]) <= new Date(tempRange[1])) {
                                        const updatedRanges = [
                                            ...form.values.availabilityDates,
                                            {
                                            startDate: tempRange[0],
                                            endDate: tempRange[1],
                                            },
                                        ].sort((a, b) => a.startDate - b.startDate);
                                        form.setFieldValue("availabilityDates", updatedRanges);
                                        setTempRange([]);
                                        }
                                    }}
                                    >
                                    Ajouter la plage
                                    </Button>
                                </>
                            )}
                            {form.values.contrat === "Location" && tempRange && tempRange[0] && !tempRange[1] && (
                                <p style={{ color: 'red', fontSize: '13px', margin: '4px 0 0' }}>
                                    Cliquez sur "Ajouter la plage" pour valider vos dates
                                </p>
                            )}
                            {form.values.contrat === "Location" && form.errors.availabilityDates && (
                                <p style={{ color: 'red', fontSize: '13px', margin: '4px 0 0' }}>
                                    {form.errors.availabilityDates}
                                </p>
                            )}
                            {form.values.contrat === "Location" && (
                                <p style={{ color: '#868e96', fontSize: '12px', margin: '8px 0 4px' }}>
                                    Les locataires pourront uniquement réserver à l'intérieur d'une même plage. Ajoutez chaque période de disponibilité séparément.
                                </p>
                            )}
                             <div className="mrgB10"></div>
                            {form.values.availabilityDates?.map((range, index) =>
                                range?.startDate && range?.endDate ? (
                                    <div
                                    key={index}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        marginBottom: "8px",
                                    }}
                                    >
                                    <div>
                                        {new Date(range.startDate).toLocaleDateString("fr-FR")} -{" "}
                                        {new Date(range.endDate).toLocaleDateString("fr-FR")}
                                    </div>

                                    <IconTrash
                                        size={18}
                                        style={{ cursor: "pointer", color: "#000000" }}
                                        onClick={() => form.removeListItem("availabilityDates", index)}
                                    />
                                    </div>
                                ) : null
                            )}
                            <div className="mrgB20"></div>

                            <TextInput
                                variant="filled"
                                placeholder="Titre de votre offre"
                                withAsterisk
                                required
                                {...form.getInputProps('title')}
                                 styles={{
                                    input: {
                                        color: 'black',
                                        fontWeight: 600,
                                    },
                                    placeholder: {
                                        fontWeight: 600,
                                    },
                                    groupLabel: {
                                        fontSize: '13px',
                                        fontWeight: 700,
                                        color: '#2e7d32',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        paddingTop: '8px',
                                    },
                                }}
                            />
                            <div className="mrgB10"></div>

                            <Textarea
                                variant="filled"
                                placeholder="Description de votre ressource"
                                {...form.getInputProps('description')}
                                 styles={{
                                    input: {
                                        color: 'black',
                                        fontWeight: 600,
                                    },
                                    placeholder: {
                                    fontWeight: 600,
                                    },
                                }}
                                minRows={5}
                                />
                            <div className="mrgB10"></div>

                            {form.values.contrat === "Vente" && (
                                <>
                                <div style={{ display: "flex", gap: 16 }}>
                                    <Checkbox
                                        label="Remise en main propre"
                                        checked={form.values.handDelivery}
                                        onChange={(e) => {
                                            const checked = e.currentTarget.checked;
                                            if (!checked && !form.values.shipping) return;
                                            form.setFieldValue('handDelivery', checked);
                                        }}
                                    />
                                    <Checkbox
                                        label="Livraison"
                                        checked={form.values.shipping}
                                        onChange={(e) => {
                                            const checked = e.currentTarget.checked;
                                            if (!checked && !form.values.handDelivery) return;
                                            form.setFieldValue('shipping', checked);
                                        }}
                                    />
                                </div>
                                <div className="mrgB10"></div>
                                </>
                            )}

                            <Textarea
                                variant="filled"
                                placeholder="Autres instructions - ex : Horaires, Parking, Accès, etc."
                                {...form.getInputProps('rules')}
                                 styles={{
                                    input: {
                                        color: 'black',
                                        fontWeight: 600,
                                    },
                                    placeholder: {
                                    fontWeight: 600,
                                    },
                                }}
                                minRows={5}
                                />
                            <div className="mrgB10"></div>

                            <Autocomplete
                            label="Ville ou code postal"
                            placeholder="Ex : Paris ou 75012"
                            value={query}
                            error={form.errors.cityOfIntervention}
                            onChange={(value) => {
                                setQuery(value);
                                form.setFieldValue("cityOfIntervention", "");
                                handleQueryChange(value);
                            }}
                            onItemSubmit={(item) => {
                                const value = item.value;
                                setQuery(value);
                                form.setFieldValue("cityOfIntervention", value);
                                form.clearFieldError("cityOfIntervention");
                            }}
                            onBlur={() => form.validateField("cityOfIntervention")}
                            data={options}
                            />
                            <div className="mrgB10"></div>

                             <ResourceCategorySelect
                                {...form.getInputProps('ressource')}
                            />
                            <div className="mrgB10"></div>

                            {form.values.contrat !== "Location" && RessourcesRequiringWeight.includes(form.values.ressource) && (
                                <>
                                    <TextInput
                                        label="Poids (kg)"
                                        placeholder="Ex : 25"
                                        withAsterisk
                                        {...form.getInputProps('weightKg')}
                                    />
                                    <p className="txt11 thin dGreyT">Utilisé pour estimer le CO₂ potentiellement évité par le réemploi.</p>
                                    <div className="mrgB10"></div>
                                </>
                            )}

                            {(form.values.contrat === "Location" || form.values.contrat === "Vente") &&
                                <div className='horizontal iEnd'>
                                <div className='w90'>
                                    <TextInput
                                        label="Prix"
                                        withAsterisk
                                        value={form.values.price}
                                        onChange={(event) => form.setFieldValue('price', event.currentTarget.value)}
                                        rightSection="€"
                                        styles={{
                                            input: { color: 'black', fontWeight: 600 },
                                            placeholder: { fontWeight: 600 },
                                        }}
                                        error={
                                            !/^(\d+([.,]\d{0,2})?)?$/.test(form.values.price)
                                            ? 'Veuillez entrer un nombre valide (max 2 décimales)'
                                            : null
                                        }
                                    />




                                </div>
                                <div className='mrgR10'></div>
                                <div className='w50'>
                                    {form.values.contrat === "Location" &&
                                        <Select
                                            variant="default"
                                            placeholder="prix par .."
                                            data={[
                                                { value: 'jour', label: '/ jour' },
                                            ]}
                                            withAsterisk
                                            required
                                            {...form.getInputProps('rentUnit')}
                                            styles={{
                                                input: {
                                                    color: 'black',
                                                    fontWeight: 600,
                                                },
                                                placeholder: {
                                                    fontWeight: 600,
                                                },
                                            }}
                                        />
                                    }
                                </div>
                                </div>
                            }
                            {form.values.contrat === "Location" && (
                                <>
                                <div className="mrgB10"></div>
                                <TextInput
                                    ref={cautionInputRef}
                                    label="Caution (optionnel)"
                                    placeholder="Montant de la caution"
                                    value={form.values.caution}
                                    onChange={(e) => form.setFieldValue('caution', e.currentTarget.value)}
                                    rightSection="€"
                                    error={(() => {
                                        if (form.values.caution === '') return null;
                                        if (!/^(\d+([.,]\d{0,2})?)?$/.test(form.values.caution)) return 'Veuillez entrer un nombre valide';
                                        return null;
                                    })()}
                                    styles={{
                                        input: { color: 'black', fontWeight: 600 },
                                    }}
                                />
                                </>
                            )}
                            <div className="mrgB10"></div>

                            {submitError && (
                                <p style={{ color: '#e03131', fontSize: 13, marginBottom: 8 }}>{submitError}</p>
                            )}

                            <SyndicRectangleButton
                                type="submit"
                                disabled={
                                    isSubmitting ||
                                    !form.values.contrat ||
                                    !form.values.title ||
                                    (form.values.contrat !== "Don" && !form.values.price) ||
                                    !form.values.ressource ||
                                    !form.values.cityOfIntervention ||
                                    (form.values.contrat === "Location" && tempRange && tempRange[0] && !tempRange[1])
                                }
                            >
                                {isSubmitting ? "Publication en cours..." : "Visualiser mon offre"}
                            </SyndicRectangleButton>

                            <div className="mrgB30"></div>

                        </div>
                    </form>
                </>
            ) : (
                <>
                    <AppDesktopLogo/>
                    <div className="offer-desktop-page-bg">
                    <div className="offer-form-card">
                    <AddOfferHd>Publier une nouvelle offre</AddOfferHd>
                    <form className="offer-form-darker-placeholders" onSubmit={form.onSubmit(handleFormSubmit)}>
                        <div>
                            <div className='horizontal jCenter'>
                                {previewPictures.length > 0 
                                    ?   <div className='horizontal jCenter mrgB5'>
                                            {previewPictures.map( (picture, index) => (
                                                <div key = {picture} style = {{marginRight : '5px'}} className='vertical imgRelative'>
                                                    <img className='img78x78T' src={picture} alt='photo_chantier'/>
                                                    <button value={picture} onClick={deleteImg} className='btnReset imgDeleteImgBtnAbsolute mrgR5 mrgT5 bold bLiteTransparent'><IconX width={13} height={13}/></button>
                                                </div>
                                            ))}
                                        </div>
                                    :   ""
                                }

                                <FileButton
                                    className='img78x78T' 
                                    multiple
                                    onChange={fileBrowseHandler}
                                    accept="image/png,image/jpeg,image/jpg">
                                    {(props) => <Button variant="default" {...props}>
                                        <div className='vertical iCenter'>
                                            <IconPlus width={20}/> 
                                            <p className='noMrgTB txt11'>Ajouter photo (3 max)</p>
                                        </div> 
                                    </Button>}
                                </FileButton>

                                {openModalImgLimit  
                                    ?   <Modal 
                                            centered
                                            size="auto"
                                            opened={openedImgLimit}
                                            onClose={closeModalImgLimit}
                                            withCloseButton={false}>
                                            <p className=" txt15 txtCenter noMrgTB">
                                                Chargement de 3 photos maximum
                                            </p>
                                        </Modal> 
                                    :   ""
                                }

                                {openModalExistingImg  
                                    ?   <Modal 
                                            centered
                                            size="auto"
                                            opened={openedExistingImg}
                                            onClose={closeModalExistingImg}
                                            withCloseButton={false}>
                                            <p className=" txt15 txtCenter noMrgTB">
                                                Photo déjà téléchargée
                                            </p>
                                        </Modal> 
                                    :   ""
                                }
                                
                                {openModalTooBigImg  
                                    ?   <Modal 
                                            centered
                                            size="auto"
                                            opened={openedTooBigImg}
                                            onClose={closeModalTooBigImg}
                                            withCloseButton={false}>
                                            <p className="tCenter noMrgTB">
                                                10 Mo Maximum par photo
                                            </p>
                                        </Modal> 
                                    :   ""
                                }
                                {openModalWrongType
                                    ?   <Modal
                                            centered
                                            size="auto"
                                            opened={openedModalWrongType}
                                            onClose={closeModalWrongType}
                                            withCloseButton={false}>
                                            <p className="oMrgTB">
                                                Fichiers autorisés : .png, .jpeg, .jpg
                                            </p>
                                        </Modal>
                                    :   ""
                                }
                                {openedModalDraftPicturesLost
                                    ?   <Modal
                                            centered
                                            size="auto"
                                            opened={openedModalDraftPicturesLost}
                                            onClose={closeModalDraftPicturesLost}
                                            withCloseButton={false}>
                                            <p className="tCenter noMrgTB">
                                                Vos photos sont trop lourdes pour être conservées pendant l'enregistrement de votre carte. Réduisez leur nombre ou leur taille, puis réessayez.
                                            </p>
                                        </Modal>
                                    :   ""
                                }
                            </div>
                            <div className='mrgB10'></div>
                            <Select
                                variant="filled"
                                placeholder="Type de contrat"
                                data={[
                                    { value: 'Vente', label: 'Vente' },
                                    { value: 'Location', label: 'Location/Prestation' },
                                    { value: 'Don', label: 'Don' },
                                ]}
                                withAsterisk
                                {...form.getInputProps('contrat')}
                                onChange={handleContratChange}
                                 styles={{
                                    input: {
                                        color: 'black',
                                        fontWeight: 600,
                                    },
                                    placeholder: {
                                        fontWeight: 600,
                                    },
                                    groupLabel: {
                                        fontSize: '13px',
                                        fontWeight: 700,
                                        color: '#2e7d32',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        paddingTop: '8px',
                                    },
                                }}
                            />
                            <div className="mrgB10"></div>

                            {form.values.contrat === "Location" && (
                                <>    
                                <DatePickerInput
                                    type="range"
                                    allowSingleDateInRange
                                    value={tempRange}
                                    onChange={setTempRange}
                                    minDate={addDays(new Date(), 1)}
                                    maxDate={addYears(new Date(), 3)}
                                    placeholder="📅 Sélectionnez une plage"
                                    valueFormat="DD MMM YYYY"
                                    locale="fr"
                                    excludeDate={(date) => {
                                        const day = date.getDay();
                                        if (!form.values.allowWeekends && (day === 0 || day === 6)) return true;
                                        if (!form.values.allowHolidays && isFrenchHoliday(date)) return true;
                                        return form.values.availabilityDates?.some((range) => {
                                            if (!range?.startDate || !range?.endDate) return false;
                                            const current = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                                            const start = new Date(range.startDate.getFullYear(), range.startDate.getMonth(), range.startDate.getDate());
                                            const end = new Date(range.endDate.getFullYear(), range.endDate.getMonth(), range.endDate.getDate());
                                            return current >= start && current <= end;
                                        });
                                    }}
                                />

                                <div style={{ display: "flex", gap: 16, marginTop: 8 }}>
                                    <Checkbox
                                        label="Autoriser les week-ends"
                                        checked={form.values.allowWeekends}
                                        onChange={(e) => form.setFieldValue('allowWeekends', e.currentTarget.checked)}
                                    />
                                    <Checkbox
                                        label="Autoriser les jours fériés"
                                        checked={form.values.allowHolidays}
                                        onChange={(e) => form.setFieldValue('allowHolidays', e.currentTarget.checked)}
                                    />
                                </div>
                                <Button
                                    className='mrgT5'
                                    color="dark"
                                    onClick={() => {
                                        if (tempRange && tempRange[0] && tempRange[1] && new Date(tempRange[0]) <= new Date(tempRange[1])) {
                                        const updatedRanges = [
                                            ...form.values.availabilityDates,
                                            {
                                            startDate: tempRange[0],
                                            endDate: tempRange[1],
                                            },
                                        ].sort((a, b) => a.startDate - b.startDate);
                                        form.setFieldValue("availabilityDates", updatedRanges);
                                        setTempRange([]);
                                        }
                                    }}
                                    >
                                    Ajouter la plage
                                    </Button>
                                </>
                            )}
                            {form.values.contrat === "Location" && tempRange && tempRange[0] && !tempRange[1] && (
                                <p style={{ color: 'red', fontSize: '13px', margin: '4px 0 0' }}>
                                    Cliquez sur "Ajouter la plage" pour valider vos dates
                                </p>
                            )}
                            {form.values.contrat === "Location" && form.errors.availabilityDates && (
                                <p style={{ color: 'red', fontSize: '13px', margin: '4px 0 0' }}>
                                    {form.errors.availabilityDates}
                                </p>
                            )}
                            {form.values.contrat === "Location" && (
                                <p style={{ color: '#868e96', fontSize: '12px', margin: '8px 0 4px' }}>
                                    Les locataires pourront uniquement réserver à l'intérieur d'une même plage. Ajoutez chaque période de disponibilité séparément.
                                </p>
                            )}
                             <div className="mrgB10"></div>
                            {form.values.availabilityDates?.map((range, index) =>
                                range?.startDate && range?.endDate ? (
                                    <div
                                    key={index}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        marginBottom: "8px",
                                    }}
                                    >
                                    <div>
                                        {new Date(range.startDate).toLocaleDateString("fr-FR")} -{" "}
                                        {new Date(range.endDate).toLocaleDateString("fr-FR")}
                                    </div>

                                    <IconTrash
                                        size={18}
                                        style={{ cursor: "pointer", color: "#000000" }}
                                        onClick={() => form.removeListItem("availabilityDates", index)}
                                    />
                                    </div>
                                ) : null
                            )}
                            <div className="mrgB20"></div>

                            <TextInput
                                variant="filled"
                                placeholder="Titre de votre offre"
                                withAsterisk
                                required
                                {...form.getInputProps('title')}
                                 styles={{
                                    input: {
                                        color: 'black',
                                        fontWeight: 600,
                                    },
                                    placeholder: {
                                        fontWeight: 600,
                                    },
                                    groupLabel: {
                                        fontSize: '13px',
                                        fontWeight: 700,
                                        color: '#2e7d32',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        paddingTop: '8px',
                                    },
                                }}
                            />
                            <div className="mrgB10"></div>

                            <Textarea
                                variant="filled"
                                placeholder="Description de votre ressource"
                                {...form.getInputProps('description')}
                                 styles={{
                                    input: {
                                        color: 'black',
                                        fontWeight: 600,
                                    },
                                    placeholder: {
                                    fontWeight: 600,
                                    },
                                }}
                                minRows={5}
                                />
                            <div className="mrgB10"></div>

                            {form.values.contrat === "Vente" && (
                                <>
                                <div style={{ display: "flex", gap: 16 }}>
                                    <Checkbox
                                        label="Remise en main propre"
                                        checked={form.values.handDelivery}
                                        onChange={(e) => {
                                            const checked = e.currentTarget.checked;
                                            if (!checked && !form.values.shipping) return;
                                            form.setFieldValue('handDelivery', checked);
                                        }}
                                    />
                                    <Checkbox
                                        label="Livraison"
                                        checked={form.values.shipping}
                                        onChange={(e) => {
                                            const checked = e.currentTarget.checked;
                                            if (!checked && !form.values.handDelivery) return;
                                            form.setFieldValue('shipping', checked);
                                        }}
                                    />
                                </div>
                                <div className="mrgB10"></div>
                                </>
                            )}

                            <Textarea
                                variant="filled"
                                placeholder="Autres instructions - ex : Horaires, Parking, Accès, etc."
                                {...form.getInputProps('rules')}
                                 styles={{
                                    input: {
                                        color: 'black',
                                        fontWeight: 600,
                                    },
                                    placeholder: {
                                    fontWeight: 600,
                                    },
                                }}
                                minRows={5}
                                />
                            <div className="mrgB10"></div>

                            <Autocomplete
                            label="Ville ou code postal"
                            placeholder="Ex : Paris ou 75012"
                            value={query}
                            error={form.errors.cityOfIntervention}
                            onChange={(value) => {
                                setQuery(value);
                                form.setFieldValue("cityOfIntervention", "");
                                handleQueryChange(value);
                            }}
                            onItemSubmit={(item) => {
                                const value = item.value;
                                setQuery(value);
                                form.setFieldValue("cityOfIntervention", value);
                                form.clearFieldError("cityOfIntervention");
                            }}
                            onBlur={() => form.validateField("cityOfIntervention")}
                            data={options}
                            />
                            <div className="mrgB10"></div>

                             <ResourceCategorySelect
                                {...form.getInputProps('ressource')}
                            />
                            <div className="mrgB10"></div>

                            {form.values.contrat !== "Location" && RessourcesRequiringWeight.includes(form.values.ressource) && (
                                <>
                                    <TextInput
                                        label="Poids (kg)"
                                        placeholder="Ex : 25"
                                        withAsterisk
                                        {...form.getInputProps('weightKg')}
                                    />
                                    <p className="txt11 thin dGreyT">Utilisé pour estimer le CO₂ potentiellement évité par le réemploi.</p>
                                    <div className="mrgB10"></div>
                                </>
                            )}

                            {(form.values.contrat === "Location" || form.values.contrat === "Vente") &&
                                <div className='horizontal iEnd'>
                                <div className='w90'>
                                    <TextInput
                                        label="Prix"
                                        withAsterisk
                                        value={form.values.price}
                                        onChange={(event) => form.setFieldValue('price', event.currentTarget.value)}
                                        rightSection="€"
                                        styles={{
                                            input: { color: 'black', fontWeight: 600 },
                                            placeholder: { fontWeight: 600 },
                                        }}
                                        error={
                                            !/^(\d+([.,]\d{0,2})?)?$/.test(form.values.price)
                                            ? 'Veuillez entrer un nombre valide (max 2 décimales)'
                                            : null
                                        }
                                    />




                                </div>
                                <div className='mrgR10'></div>
                                <div className='w50'>
                                    {form.values.contrat === "Location" &&
                                        <Select
                                            variant="default"
                                            placeholder="prix par .."
                                            data={[
                                                { value: 'jour', label: '/ jour' },
                                            ]}
                                            withAsterisk
                                            required
                                            {...form.getInputProps('rentUnit')}
                                            styles={{
                                                input: {
                                                    color: 'black',
                                                    fontWeight: 600,
                                                },
                                                placeholder: {
                                                    fontWeight: 600,
                                                },
                                            }}
                                        />
                                    }
                                </div>
                                </div>
                            }
                            {form.values.contrat === "Location" && (
                                <>
                                <div className="mrgB10"></div>
                                <TextInput
                                    ref={cautionInputRef}
                                    label="Caution (optionnel)"
                                    placeholder="Montant de la caution"
                                    value={form.values.caution}
                                    onChange={(e) => form.setFieldValue('caution', e.currentTarget.value)}
                                    rightSection="€"
                                    error={(() => {
                                        if (form.values.caution === '') return null;
                                        if (!/^(\d+([.,]\d{0,2})?)?$/.test(form.values.caution)) return 'Veuillez entrer un nombre valide';
                                        return null;
                                    })()}
                                    styles={{
                                        input: { color: 'black', fontWeight: 600 },
                                    }}
                                />
                                </>
                            )}
                            <div className="mrgB10"></div>

                            {submitError && (
                                <p style={{ color: '#e03131', fontSize: 13, marginBottom: 8 }}>{submitError}</p>
                            )}

                            <div className="horizontal jCenter">
                            <Button color="dark" radius="xl" size="lg" styles={{ label: { fontSize: 16, fontWeight: 500 } }}
                                type="submit"
                                disabled={
                                    isSubmitting ||
                                    !form.values.contrat ||
                                    !form.values.title ||
                                    (form.values.contrat !== "Don" && !form.values.price) ||
                                    !form.values.ressource ||
                                    !form.values.cityOfIntervention ||
                                    (form.values.contrat === "Location" && tempRange && tempRange[0] && !tempRange[1])
                                }
                            >
                                {isSubmitting ? "Publication en cours..." : "Visualiser mon offre"}
                            </Button>
                            </div>

                        </div>
                    </form>
                    </div>
                    </div>
                </>
            )}
        </>

    );
}

  export default AddNewOffer;

